import { Pipe, PipeTransform } from '@angular/core';

import { compact, isEmpty, isNil } from 'lodash-es';

import { OwnerNameEnum } from '../../enums/owner-name';
import { WalkingFarmProperty } from '../../typings/walking-farm';

@Pipe({
  name: 'redOwnerName',
  standalone: false
})
export class OwnerNamePipe implements PipeTransform {
  transform(value: WalkingFarmProperty, arg: OwnerNameEnum = OwnerNameEnum.Full, defaultValue = '--') {
    let result = '';

    if (!isNil(value)) {
      const parsedOwner = this.parseOwnerName(value);

      switch (arg) {
        case OwnerNameEnum.First:
          result = compact([
            parsedOwner.Owner1FirstName,
            parsedOwner.Owner1MiddleName,
            parsedOwner.Owner1LastName
          ]).join(' ');
          break;
        case OwnerNameEnum.Second:
          result = compact([
            parsedOwner.Owner2FirstName,
            parsedOwner.Owner2MiddleName,
            parsedOwner.Owner2LastName
          ]).join(' ');
          break;
        default:
          result = compact([
            compact([parsedOwner.Owner1FirstName, parsedOwner.Owner1MiddleName, parsedOwner.Owner1LastName]).join(' '),
            compact([parsedOwner.Owner2FirstName, parsedOwner.Owner2MiddleName, parsedOwner.Owner2LastName]).join(' ')
          ]).join(' / ');
          break;
      }
    }

    if (isEmpty(result)) {
      result = defaultValue;
    }

    return result;
  }

  private parseOwnerName(value: WalkingFarmProperty): {
    Owner1FirstName: string;
    Owner1LastName: string;
    Owner1MiddleName: string;
    Owner2FirstName: string;
    Owner2LastName: string;
    Owner2MiddleName: string;
  } {
    return {
      Owner1FirstName: value.A010_Owner1FirstName,
      Owner1LastName: value.A012_Owner1LastName,
      Owner1MiddleName: value.A011_Owner1MiddleName,
      Owner2FirstName: value.A013_Owner2FirstName,
      Owner2LastName: value.A015_Owner2LastName,
      Owner2MiddleName: value.A014_Owner2MiddleName
    };
  }
}
